import React from "react";
import styles from "./UserImage.module.scss";
import Image from "next/image";
import { ImageType } from "@/types/baseTypes";
import { iconToImageSrc } from "@/utils/iconToImageSrc";

interface UserImageProps extends React.HTMLAttributes<HTMLDivElement> {
  image: UserImageInput;
}

type UserImageInput = ImageType | string;

const isImageType = (img: UserImageInput): img is ImageType =>
  typeof img === "object" && img !== null && "url" in img;

export const UserImage = ({ image, className, ...props }: UserImageProps) => {
  const src = isImageType(image) ? image.url : iconToImageSrc(image);
  const finalAlt = isImageType(image) ? image.alt : "avatar";

  return (
    <div {...props} className={`${styles["user-image"]} ${className ?? ""}`}>
      <Image src={src} fill alt={finalAlt || "avatar"} quality={90} />
    </div>
  );
};
